const rgba2hex = (rgba) => `#${rgba.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+\.{0,1}\d*))?\)$/).slice(1).map((n, i) => (i === 3 ? Math.round(parseFloat(n) * 255) : parseFloat(n)).toString(16).padStart(2, '0').replace('NaN', '')).join('')}`;

const lastContentEl = document.querySelector('.page-content > .content-block-layout:last-child');
if (lastContentEl) {
    const lastContentBgColor = window.getComputedStyle(lastContentEl).backgroundColor;
    const lastContentBgHex = rgba2hex(lastContentBgColor).toUpperCase();

    if (lastContentBgHex === '#00000000' || lastContentBgHex === '#FFFFFF') {
        if (document.querySelector('footer')) document.querySelector('footer').classList.add('alt-bg');
    }
}